module.exports = {
    clientID: "OGqZ7q1osiX39eNsxvrRWLTLUmOx7TZH",
    domain: "manahours.auth0.com"
};
